import React from 'react';
import { Panel, Tab, Nav, NavItem, Row, Col } from 'react-bootstrap';
import { isNumber, isArray, isEmpty } from 'lodash';
import AccessorialRatesPropsEditor from './AccessorialRatesPropsEditor';
import AccessorialRatesWeightBaseEditor from './AccessorialRatesWeightBaseEditor';
import AccessorialRatesVehicleBaseEditor from './AccessorialRatesVehicleBaseEditor';
import AccessorialRatesPassThruEditor from './AccessorialRatesPassThruEditor';
import AccessorialRatesFlatFeeEditor from './AccessorialRatesFlatFeeEditor';
import AccessorialRatesPercentOfTariffEditor from './AccessorialRatesPercentOfTariffEditor';
import AccessorialRatesTimeBaseEditor from './AccessorialRatesTimeBaseEditor';
import AccessorialRatesSurchargeEditor from './AccessorialRatesSurchargeEditor';
export default class AccessorialRatesEditor extends React.Component {
    handlePropertiesChange() {
        return (key, value) => {
            const accessorialRate = this.props.accessorialRate;
            accessorialRate[key] = value;
            let valid = accessorialRate.name && accessorialRate.name.length > 0;
            if (isNumber(value)) {
                valid = valid && (value > 0);
            }
            this.notifyUpdate(accessorialRate, true, valid);
        };
    }
    handleWeightBaseChange() {
        return (accessorialRate) => {
            this.notifyUpdate(accessorialRate, true, this.validateWeightBase(accessorialRate));
        };
    }
    handleVehicleChange() {
        return (vehicles) => {
            const accessorialRate = this.props.accessorialRate;
            accessorialRate.vehicle_rates = vehicles;
            this.notifyUpdate(accessorialRate, true, this.validateVehicle(vehicles));
        };
    }
    handleSurchargeChange() {
        return (surcharge) => {
            const accessorialRate = this.props.accessorialRate;
            accessorialRate.special_surcharge = surcharge;
            this.notifyUpdate(accessorialRate, true, this.validateSurcharge(surcharge));
        };
    }
    notifyUpdate(accessorialRate, edited, valid) {
        if (this.props.onChange) {
            this.props.onChange(accessorialRate, edited, valid);
        }
    }
    validateVehicle(vehicles) {
        let valid = true;
        if (isArray(vehicles)) {
            for (const vehicle of vehicles) {
                if (isEmpty(vehicle.type)) {
                    valid = false;
                    break;
                }
                if (vehicle.rate <= 0) {
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    validateWeightBase(accessorialRate) {
        let valid = true;
        if (accessorialRate) {
            valid = valid && accessorialRate.rate && accessorialRate.rate > 0;
            valid = valid && accessorialRate.minimum_rate >= 0 && accessorialRate.maximum_rate >= accessorialRate.minimum_rate;
            valid = valid && accessorialRate.free >= 0;
        }
        return valid;
    }
    validateSurcharge(surcharge) {
        let valid = true;
        if (surcharge) {
            valid = valid && this.validateRanges(surcharge.weight_ranges);
            valid = valid && this.validateRates(surcharge.rates);
        }
        return valid;
    }
    validateValues(values) {
        let valid = true;
        if (isArray(values)) {
            for (const value of values) {
                if (value <= 0) {
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    validateRanges(ranges) {
        let valid = true;
        if (ranges) {
            for (let index = 0; index < ranges.length; ++index) {
                const range = ranges[index];
                if (isArray(range)) {
                    valid = (range[0] > 0 && range[1] >= range[0]);
                    if (!valid) {
                        break;
                    }
                }
                else {
                    break;
                }
            }
        }
        return valid;
    }
    validateRates(rates) {
        let valid = true;
        if (rates) {
            for (let index = 0; index < rates.length; ++index) {
                const row = rates[index];
                valid = this.validateValues(row);
                if (!valid)
                    break;
            }
        }
        return valid;
    }
    renderWeightBaseTab() {
        const display = this.props.accessorialRate.type === 'weightBase' ? 'block' : 'none';
        return (React.createElement(Panel, { style: { display: display } },
            React.createElement(AccessorialRatesWeightBaseEditor, { accessorialRate: this.props.accessorialRate, onChange: this.handleWeightBaseChange() })));
    }
    renderVehicleBaseTab() {
        const display = this.props.accessorialRate.type === 'vehicleBase' ? 'block' : 'none';
        return (React.createElement(Panel, { style: { display: display } },
            React.createElement(AccessorialRatesVehicleBaseEditor, { accessorialRate: this.props.accessorialRate, onChange: this.handleVehicleChange() })));
    }
    renderPassThruTab() {
        const display = this.props.accessorialRate.type === 'passThru' ? 'block' : 'none';
        return (React.createElement(Panel, { style: { display: display } },
            React.createElement(AccessorialRatesPassThruEditor, { accessorialRate: this.props.accessorialRate, onChange: this.handlePropertiesChange() })));
    }
    renderFlatFeeTab() {
        const display = this.props.accessorialRate.type === 'flatFee' ? 'block' : 'none';
        return (React.createElement(Panel, { style: { display: display } },
            React.createElement(AccessorialRatesFlatFeeEditor, { accessorialRate: this.props.accessorialRate, onChange: this.handlePropertiesChange() })));
    }
    renderPersentTab() {
        const display = this.props.accessorialRate.type === 'percentOfTariff' ? 'block' : 'none';
        return (React.createElement(Panel, { style: { display: display } },
            React.createElement(AccessorialRatesPercentOfTariffEditor, { accessorialRate: this.props.accessorialRate, onChange: this.handlePropertiesChange() })));
    }
    renderTimeBaseTab() {
        const display = this.props.accessorialRate.type === 'timeBase' ? 'block' : 'none';
        return (React.createElement(Panel, { style: { display: display } },
            React.createElement(AccessorialRatesTimeBaseEditor, { accessorialRate: this.props.accessorialRate, onChange: this.handlePropertiesChange() })));
    }
    renderSurchargeTab() {
        const display = this.props.accessorialRate.type === 'specialSurcharge' ? 'block' : 'none';
        return (React.createElement(Panel, { className: "table-responsive", style: { display: display } },
            React.createElement(AccessorialRatesSurchargeEditor, { accessorialRate: this.props.accessorialRate, onChange: this.handleSurchargeChange() })));
    }
    render() {
        const disableDetail = !(this.props.accessorialRate && this.props.accessorialRate._id);
        return (React.createElement("div", null,
            React.createElement(Tab.Container, { id: "left-tabs-example", defaultActiveKey: "1" },
                React.createElement(Row, { className: "clearfix" },
                    React.createElement(Col, { sm: 2 },
                        React.createElement(Nav, { bsStyle: "pills", stacked: true },
                            React.createElement(NavItem, { eventKey: "1" }, "Properties"),
                            React.createElement(NavItem, { eventKey: "2", disabled: disableDetail }, "Details"))),
                    React.createElement(Col, { sm: 10 },
                        React.createElement(Tab.Content, { animation: true },
                            React.createElement(Tab.Pane, { eventKey: "1" },
                                React.createElement(Panel, null,
                                    React.createElement(AccessorialRatesPropsEditor, { accessorialRate: this.props.accessorialRate, onChange: this.handlePropertiesChange() }))),
                            React.createElement(Tab.Pane, { eventKey: "2" },
                                this.renderFlatFeeTab(),
                                this.renderPersentTab(),
                                this.renderTimeBaseTab(),
                                this.renderWeightBaseTab(),
                                this.renderVehicleBaseTab(),
                                this.renderPassThruTab(),
                                this.renderSurchargeTab())))))));
    }
}
